import { createSlice } from '@reduxjs/toolkit';
export interface User {
  token: string;
  email: string;
  isOnboarding: boolean;
  isDisclosed: boolean;
  isGithubUser: boolean;
}
const initialState: User = {
  token: localStorage.getItem('refresh_token') || '',
  email: '',
  isOnboarding: false,
  isDisclosed: localStorage.getItem('disclosure') !== 'true',
  isGithubUser: false,
};
export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setEmail: (state, action) => {
      return { ...state, email: action.payload };
    },
    setToken: (state, action) => {
      return { ...state, token: action.payload };
    },
    setOnboarding: (state, action) => {
      return { ...state, isOnboarding: action.payload };
    },
    setIsGithubUser: (state, action) => {
      return { ...state, isGithubUser: action.payload };
    },
  },
});
// Action creators are generated for each case reducer function
export const { setToken, setEmail, setOnboarding, setIsGithubUser } =
  userSlice.actions;

export default userSlice.reducer;
